export const moduleURI = {
	dashboard: {
		key: 1,
		link: '/',
	},
	createLabReq: {
		key: 2,
		link: '/request/create/step/1',
	},
	editLabReq: {
		key: 3,
		link: '/request/edit/step/1',
	},
	viewLabReq: {
		key: 4,
		link: '/request/view/search',
	},
	phlebo: {
		key: 5,
		link: '/phlebo/result',
	},
	editLabResult: {
		key: 6,
		link: '/lab/result/edit',
	},
	printLabResult: {
		key: 7,
		link: '/lab/result/print',
	},
	searchPatient: {
		key: 8,
		link: '/patient/search',
	},
	settings: {
		key: 9,
		link: '/settings',
	},
	inventory: {
		key: 10,
		link: '/inventory',
	},
	checkIn: {
		key: 11,
		link: '/checkin',
	},
	bloodbank: {
		key: 17,
		link: '/bloodbank',
	},
	cashier: {
		key: 18,
		link: '/cashier',
	},
	dataAnalysis: {
		key: 19,
		link: '/data-analysis',
	},
};

export default moduleURI;
